import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';

import { trackEvent } from 'lib/posthog';

import { CLICK_COUPON_CTA } from 'constants/analytics';

const WHATSAPP_GROUP_URL = process.env.NEXT_PUBLIC_WHATSAPP_GROUP_URL;

const WhatsappIcon = () => (
  <svg
    aria-hidden="true"
    className="mr-2 shrink-0"
    fill="currentColor"
    height="20"
    viewBox="0 0 24 24"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const handleClick = () => {
  trackEvent(CLICK_COUPON_CTA, { option: 'whatsapp_group' });
  window.open(WHATSAPP_GROUP_URL, '_blank', 'noopener,noreferrer');
};

const WhatsappGroupCtaCard = () => {
  if (!WHATSAPP_GROUP_URL) return null;

  return (
    <Box className="grid min-h-36 grid-cols-[96px_1fr] gap-x-6 gap-y-2 rounded-4 border-2 border-success-200 p-4 dark:border-success-200 md:grid-cols-[auto_1fr_1fr_1fr_200px] md:gap-x-8 md:px-8 md:py-6">
      <div className="row-span-2 flex h-24 w-24 flex-col items-center justify-center self-center border-r border-dashed border-neutral-high-400 pr-6 dark:border-neutral-low-200 md:pr-8 xl:w-40">
        <Heading
          as="h3"
          className="cursor-pointer text-center text-neutral-low-400 dark:text-neutral-high-200 lg:text-[28px]"
          size="size2"
          onClick={handleClick}
        >
          GRUPO
        </Heading>
      </div>
      <div className="col-start-2 row-span-2 flex flex-col gap-2 self-center md:contents">
        <Heading
          as="h2"
          className="cursor-pointer text-sm font-semibold text-neutral-low-400 dark:text-neutral-high-200 md:col-span-3 md:col-start-2 md:row-span-2 md:self-center lg:text-xl"
          size="size4"
          onClick={handleClick}
        >
          Acesse o grupo oficial e receba as melhores ofertas e cupons direto no
          seu WhatsApp
        </Heading>
        <Button
          buttonTextClassName="text-sm md:text-base flex items-center"
          className="col-start-2 h-8 w-full self-center min-size-8 md:col-span-1 md:col-start-5 md:row-span-2 md:h-12 md:w-[200px] md:self-center md:justify-self-end md:min-size-10"
          size="size3"
          type="success"
          onClick={handleClick}
        >
          <WhatsappIcon />
          Acessar Grupo
        </Button>
      </div>
    </Box>
  );
};

export default WhatsappGroupCtaCard;
